import React, { useContext, useEffect } from 'react';

import { ControlBarContext } from '../../ControlBarContext';
import { Wrapper, RightSide } from '../styledComponents';
import Provider from './context';
import Header from './Header';
import Filter from './Filter';
import List from './List';

const Page = ({ getBreadCrumbs }) => {
  const { setBreadCrumbs } = useContext(ControlBarContext);

  useEffect(() => {
    setBreadCrumbs(getBreadCrumbs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider>
      <Wrapper>
        <Header />
        <div className='body'>
          <List />
          <RightSide>
            <Filter />
          </RightSide>
        </div>
      </Wrapper>
    </Provider>
  );
};

export default Page;
